import { useEffect, useState } from "react";

export const useEmbedApp = () => {
  // App Bridge v4 会在 <head> 的 CDN 脚本同步注入 window.shopify，故可同步初始化
  const [isShopifyEmbed, setIsShopifyEmbed] = useState(
    () => typeof window !== "undefined" && typeof window.shopify !== "undefined",
  );

  useEffect(() => {
    setIsShopifyEmbed(
      typeof window !== "undefined" && typeof window.shopify !== "undefined",
    );
  }, []);

  return isShopifyEmbed;
};
